import { refreshToken } from './auth';

export const downloadCsv = (endpoint: string, extraParams?: { [key: string]: string }) => {
  return async (
    columns: string[],
    filterString?: string,
    sortField?: string,
    sortDirection?: string,
    headers?: string[]
  ) => {
    const url = new URL(`/api/${endpoint}/csv`, window.location.origin);
    url.searchParams.append('columns', columns.join(','));
    url.searchParams.append('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);

    if (sortField) {
      url.searchParams.append('sortField', sortField);
    }
    if (sortDirection) {
      url.searchParams.append('sortDirection', sortDirection);
    }
    if (filterString) {
      url.searchParams.append('filterString', filterString);
    }
    if (headers) {
      url.searchParams.append('headers', headers.join(','));
    }
    if (extraParams) {
      const params = Object.keys(extraParams);
      params.forEach(p => {
        if (extraParams[p] !== undefined) {
          url.searchParams.append(p, extraParams[p]);
        }
      });
    }

    let token = localStorage.getItem('token');
    const htmlHeaders = new Headers([
      ['Accept', 'text/csv'],
      ['Authorization', `Bearer ${token}`]
    ]);

    try {
      let response = await fetch(url, { method: 'GET', headers: htmlHeaders });
      if (response.status === 401 || response.status === 403) {
        token = await refreshToken();
        if (!token) throw new Error('Unauthenticated');
        htmlHeaders.set('Authorization', `Bearer ${token}`);
        response = await fetch(url, { method: 'GET', headers: htmlHeaders });
      }

      if (response.ok) {
        let blob = await response.blob();
        const headers = response.headers;

        const filename = headers
          .get('Content-Disposition')
          ?.split(';')
          .find(h => h.includes('filename'))
          ?.split('=')
          .at(1)
          ?.replace(/"/g, '');
        // console.log(headers);
        // console.log(filename);

        const fileUrl = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = filename ?? endpoint;
        link.click();
        link.remove();
      }
    } catch (error) {
      console.error(error);
    }
  };
};
